import { combineReducers } from "./combineReducers";
import reducer2 from "./reducers2";

export const initialState: AppState = {
  config: {
    appInProduction: true, //////////////////////////////////////////////////////////////////////// in production

    // For Language And Site Settings
    languageCode: localStorage.languageCode, // Default Language Of App
    languageDirection: localStorage.languageDirection, // Default Direction Of App
    appDirection: localStorage.languageDirection, // Application Direction
    currency: localStorage.currency, // Default Currency Of App
    dir: "ltr", // Default Direction Of App
    // For Default Site Settings Attributes
    appSettings: {}, // Application Site Settings
    newProductDuration: 20, // For New Product Duration
    address: "",
    phoneNo: "",
    notifText: "",
    notifTitle: "",
    notifDuration: "",
    footerShowHide: 1,
    wishListProducts: [], // For WishList Products
    recentViewedProducts: [], // For RecentlyViewed Products
    cartProducts: [], // For Cart Products
    cartQuantity: 0, // For Cart Quantity
    totalPrice: 0,
    singleProductPageData: [], // For Single Product Data
    singlePostData: [], // For News Single Post Data
    customerData: {} as any, // For Customer Data //
    couponArray: [] as any, // For Coupon Array
    myOrderDetailPageData: {}, // For Order Detail Page Data

    // For Shipping And Billing Address
    billing: {
      first_name: "",
      last_name: "",
      company: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      postcode: "",
      country: "",
      email: "",
      phone: "",
    },
    billingCountryName: "",
    billingStateName: "",
    shipping: {
      first_name: "",
      last_name: "",
      company: "",
      address_1: "",
      address_2: "",
      city: "",
      state: "",
      postcode: "",
      country: "",
      email: "",
      phone: "",
    },
    shippingCountryName: "",
    shippingStateName: "",
    order: {},
    shipping_lines: [],
    listTaxRates: [],
    sameAddress: false,

    // For Google MAP API Key
    googleMapId: "Place_Your_Google_API", // For Google Map API Key For Test

    // For OneSiganl
    onesignalAppId: "Place_Your_OneSignal_App_ID",
    onesignalSenderId: "Place_Your_OneSignal_Sender_ID",

    // For Featured Vendor
    storePageData: [], // For Featured Vendor
    device: "",

    // For App Themes
    appTheme: "default",
    darkMode: false,

    // For Color Schemes
    colorTheme: "",
    colorThemeSelected: false,

    // For Mode Dark/Light
    // modeTheme: 'light',
    modeThemeSelected: false,

    // For AppBrowser Colors
    headerHexColor: "#51688F",
    headerHexColorContrast: "#ffffff",
    myOrders: [],
  },
};

export const c_reducers = combineReducers({
  config: reducer2,
});

export type AppState = ReturnType<typeof c_reducers>;
